import React, { useEffect, useRef, useState } from 'react'

import { KTSVG } from '../../_metronic/helpers'
import { deleteInvoiceandSales } from '../apis/Loadalltabledata'

import { Maintable } from '../tables/Maintable'
import { useAuth } from '../../app/modules/auth'
import { useSalesInvoicesusequerypayment, useDeletesalesinvoices, useUserroles } from '../contextProviders/Atomqueryprovider'
import { useMemo } from 'react'
import { Column } from 'react-table'
import { Updateinvoice } from '../dashboard/modals/Updateinvoice'
import { Deleteinvoice } from '../dashboard/modals/Deleteinvoice'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { useQueryClient } from 'react-query'
import { getSalesInvoicesandsales } from '../apis/Loadalltabledata'
import io from 'socket.io-client'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')

export function Unpaidbills() {
  const myRefsearch: any = useRef()
  const myRefupdate: any = useRef()
  const tablename = 'Unpaid Summary'

  const [modalshowupdate, setModalshowupdate] = useState(false)
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [statedeletinginvoice, setStatedeletinginvoice] = useState(false)
  const [invoicetodelete, setInvoicetodelete] = useState<any>('')
  const [invoiceupdate, setInvoiceupdate] = useState<string>('')
  const { currentUser, logout } = useAuth()
  const [startlimit, setStartlimit] = useState<number>(0)
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [itemto_order, setItemto_order] = useState<string>('date_recorded')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['sales_info'])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const queryClient = useQueryClient()
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false);

  // Date range for queries
  const startDate = useMemo(() =>
    new Date(dayjs.unix(dayjs(dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME).unix()).format('YYYY-MM-DD hh:mm')),
    []
  );

  const endDate = useMemo(() =>
    new Date(dayjs.unix(dayjs(dayjs().add(1, 'M').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix()).format('YYYY-MM-DD hh:mm')),
    []
  );

  // Add user roles query
  const {
    isLoading: userrolesloading,
    isSuccess: userrolessuccess,
    data: userrolesdata,
  } = useUserroles(Number(currentUser?.user_role_id))

  // Add isUserAdmin function
  const isUserAdmin = () => {
    if (!userrolessuccess || !userrolesdata?.data) return false
    // Adjust this condition based on your actual role data structure
    return userrolesdata.data.role_name === 'Admin' || userrolesdata.data.is_admin === true
  }

  // Query for total (all records) - This calculates the actual unpaid total
  const {
    isSuccess: totalQuerySuccess,
    data: totalData,
    refetch: totalRefetch
  } = useSalesInvoicesusequerypayment(
    Number(currentUser?.user_id),
    0,
    999999, // Large number to get all records
    startDate,
    endDate,
    'date_recorded',
    'DESC',
    search_item, // Use same search filter
    ["CREDIT", "NOT PAID", "PARTIAL"]
  )

  // Query for paginated data - This is for display in table
  const {
    isLoading: salesinvoiceisloading,
    isSuccess: salesinvoicedsuccess,
    data: salesinvoicedata,
    isPreviousData: salesinvoiceispreviousdata,
    status: salesinvoicestatus,
    refetch: salesinvoicerefetch
  } = useSalesInvoicesusequerypayment(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    startDate,
    endDate,
    itemto_order,
    desorasc,
    search_item,
    ["CREDIT", "NOT PAID", "PARTIAL"]
  )

  // Prefetch next page
  useEffect(() => {
    if (!salesinvoiceispreviousdata) {
      queryClient.prefetchQuery(
        ['salesInvoicesusequerypayment', startlimit + paginationsize, paginationsize],
        () =>
          getSalesInvoicesandsales(
            Number(currentUser?.user_id),
            startlimit + paginationsize,
            paginationsize,
            startDate,
            endDate,
            itemto_order,
            desorasc,
            search_item,
            ["CREDIT", "NOT PAID", "PARTIAL"]
          )
      )
    }
  }, [
    salesinvoiceispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
    startDate,
    endDate
  ])

  const { mutateAsync: deleteinvoicesalesmutateAsync } = useDeletesalesinvoices(invoicetodelete.invoice_id)

  const showModalupdate = (x: any) => {
    setModalshowupdate(true)
    setInvoiceupdate(x)
    myRefupdate.current.Resetmodalupdatevalues()
  }

  const showModaldelete = (x: any) => {
    setModalshowdelete(true)
    setStatedeletinginvoice(false)
    setInvoicetodelete(x)
  }

  const truncate = require('truncate')

  const addCommas = (num: any) => {
    // Handle undefined, null, or non-numeric values
    if (num === undefined || num === null || num === '') {
      return '0'
    }

    // Convert to number if it's a string
    const numValue = typeof num === 'string' ? parseFloat(num) : num

    // Check if it's a valid number
    if (isNaN(numValue)) {
      return '0'
    }

    return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  const filteredsubdata = (rowdata: any): number => {
    return rowdata.values.sales_info.length
  }

  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.sales_info.sort((a: any, b: any) => (a.datesold > b.datesold ? -1 : 1))
  }

  // Socket listener for updates
  useEffect(() => {
    socket.on('update', async (arg) => {
      try {
        await salesinvoicerefetch()
        await totalRefetch() // Also refetch the total
      } catch (error) {
        console.log(error)
      } finally {
        console.log("refetch success")
      }
    })

    return () => {
      socket.off('update')
    }
  }, [salesinvoicerefetch, totalRefetch])

  const deleteInvoiceSales = async () => {
    setStatedeletinginvoice(true)

    deleteinvoicesalesmutateAsync(invoicetodelete.invoice_id, {
      onSuccess: () => {
        setStatedeletinginvoice(false)
        setModalshowdelete(false)
        totalRefetch() // Refetch total after deletion
      },
      onError(error, variables, context) {
        console.log(error)
        setStatedeletinginvoice(true)
        setModalshowdelete(false)
      },
    })
  }

  const tabledata = useMemo(
    () => salesinvoicedata?.data.salesinvoices,
    [salesinvoicedata?.data.salesinvoices, salesinvoicedsuccess]
  )

  const tabledata2 = useMemo(
    () => salesinvoicedata?.data.salesinvoices.map((x: any) => x.sales_info).flatMap((x: any) => x),
    [
      salesinvoicedata?.data.salesinvoices.map((x: any) => x.sales_info).flatMap((x: any) => x),
      salesinvoicedsuccess,
    ]
  )

  const tabledatalength = useMemo(
    () => salesinvoicedata?.data.datalength,
    [salesinvoicedata?.data.datalength, salesinvoicedsuccess]
  )

  // Calculate the ACTUAL unpaid total from ALL records (not just current page)
  const unpaidTotal = useMemo(() => {
    if (!totalQuerySuccess || !totalData?.data?.salesinvoices) return 0;

    const allSalesItems = totalData.data.salesinvoices
      .map((x: any) => x.sales_info)
      .flatMap((x: any) => x);

    if (allSalesItems.length === 0) return 0;

    return allSalesItems
      .map((c: any) => (c.quantity || 0) * (c.unit_price || 0))
      .reduce((a: number, b: number) => a + b, 0);
  }, [totalQuerySuccess, totalData]);

  // Updated columndata3 with conditional delete button
  const columndata3: ReadonlyArray<
    Column<{
      invoice_id: number
      total_amount: number
      amount_tendered: number
      date_recorded: string
      user_id: string
      customer_id: number
      payment_type_id: number
      status: string
      payment_type_name: string
      sales_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Id',
        accessor: 'invoice_id', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark fw-bolder fs-6'>{value}</span>

                <span className='text-nowrap  fw-bold text-muted d-block fs-7 mt-1'>
                  {truncate(
                    Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.product_name)[0],
                    20
                  )}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'sales_info',
        accessor: 'sales_info',
      },

      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => showModalupdate(row.original)}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              {/* Conditionally render delete button only for admins */}
              {isUserAdmin() && (
                <a
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  onClick={() => showModaldelete(row.original)}
                >
                  {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                  <span className='svg-icon svg-icon-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width={24}
                      height={24}
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                        fill='#f1416c'
                      />
                    </svg>
                  </span>
                  {/*end::Svg Icon*/}
                </a>
              )}
            </div>
          )
        },
      },
    ]

  const columndata4: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      unit_name: string
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
    }>
  > = [
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
              {truncate(row.original.product_name, 20)}

              <span className='h-10px border-gray-200 border-start mx-2'></span>
              <span>{row.original.quantity}</span>
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {dayjs(row.original.datesold).calendar()}
              <span className='h-10px border-gray-200 border-start mx-2'></span>
              {addCommas(row.original.sub_total.toFixed(2))} {CURRENCY_APP}{' '}
            </span>
          </>
        ),
      },
    ]

  return (
    <>
      {/* begin::unpaid bills drawer */}
      <div
        id='kt_engage_demos'
        className='bg-body'
        data-kt-drawer='true'
        data-kt-drawer-name='explore'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'90%','lg': '30%', 'md' : '50%'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_engage_demos_toggle'
        data-kt-drawer-close='#kt_engage_demos_close'
      >
        {/* begin::Card  */}
        <div className='card shadow-none w-100'>
          {/* begin::Header */}
          <div className='card-header' id='kt_explore_header'>
            <h3 className='card-title fw-bolder'>
              Unpaid Bills
            </h3>

            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
                id='kt_engage_demos_close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </button>
            </div>
          </div>
          {/* end::Header */}
          {/* begin::Body */}
          <div className='card-body' id='kt_explore_body'>
            {/* begin::Content */}

            <div className='row'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>

                {totalQuerySuccess && unpaidTotal > 0 ? (
                  <div className='d-flex align-items-center text-nowrap'>
                    <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>
                      Unpaid Total
                    </span>
                    <span className='h-50px border-gray-200 border-start mx-2'></span>
                    <div className='d-flex justify-content-start flex-column'>
                      <span className='fw-bold d-block fs-7 text-danger'>
                        {addCommas(unpaidTotal.toFixed(2))} <sup>{CURRENCY_APP}</sup>
                      </span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

              </div>

              <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>

              </div>
            </div>

            <Maintable
              tabledata={salesinvoicedsuccess ? tabledata : []}
              startlimit={startlimit}
              setstartlimit={setStartlimit}
              hiddencolumnsmade={hiddencolumnsmade}
              paginationsize={paginationsize}
              pageCount={pageCount}
              setPageCount={setPageCount}
              setPaginationsize={setPaginationsize}
              movetofirstpage={movetofirstpage}
              setMovetofirstpage={setMovetofirstpage}
              columndata={columndata3}
              tabledata2={tabledata2}
              columndata2={columndata4}
              table1loaded={salesinvoicestatus === 'success'}
              table2loaded={salesinvoicestatus === 'success'}
              tablename={tablename}
              tablelength={salesinvoicestatus === 'success' ? tabledatalength : 0}
              filteredsubdata={filteredsubdata}
              filteredtablesubData={filteredtablesubData}
              setServersort={setServersort}
            />

            {/* end::Content */}
          </div>
          {/* end::Body */}
        </div>
        {/* begin::Card */}
      </div>
      {/* end:: unpaid bills drawer */}

      <Deleteinvoice
        show={modalshowdelete}
        deleteInvoiceSales={deleteInvoiceSales}
        invoicetodelete={invoicetodelete}
        statedeletinginvoice={statedeletinginvoice}
        handleClose={function (): void {
          setModalshowdelete(false)
        }}
      />

      <Updateinvoice
        invoiceData={tabledata}
        show={modalshowupdate}
        invoiceupdate={invoiceupdate}
        handleClose={function (): void {
          setModalshowupdate(false)
        }}
        ref={myRefupdate}
      />

    </>
  )
}